import { dew as _objectDew } from "./object";
import { dew as _propertyDew } from "./property";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.property = exports.isProperty = exports.object = exports.getObjectUtils = void 0;
  var object_1 = _objectDew();
  Object.defineProperty(exports, "getObjectUtils", {
    enumerable: true,
    get: function () {
      return object_1.getObjectUtils;
    }
  });
  Object.defineProperty(exports, "object", {
    enumerable: true,
    get: function () {
      return object_1.object;
    }
  });
  var property_1 = _propertyDew();
  Object.defineProperty(exports, "isProperty", {
    enumerable: true,
    get: function () {
      return property_1.isProperty;
    }
  });
  Object.defineProperty(exports, "property", {
    enumerable: true,
    get: function () {
      return property_1.property;
    }
  });
  return exports;
}